import axios from 'axios';

export class CustodyService {

    getCustodyData() {
        return axios.get('/appapv/getCustodyData.action', {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => res.data);
    }

    getDomainCatalog(){
        return axios.get('/appapv/getDomainCustody.action', {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => res.data);
    }

    updateCustodyData(userName, password, domainObj) {
        return axios.post('/appapv/updateCustodyData.action', {}, {
            params: {
                userName: userName,
                password: password,
                idDomain: domainObj.domainId,
            }
        }).then(res => res.data);
    }
}